import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";

import {
    ExpansionPanelComponent,
    ExpansionPanelPartDirective,
} from "@hermes/aphrodite/expansion-panel";
import { SearchInputComponent } from "@hermes/aphrodite/fields";
import { MessageBlockComponent } from "@hermes/aphrodite/message-block";
import {
    svgComposition,
    SvgIconComponent,
    svgRecyclability,
    SvgRegistryService,
    svgSearch,
    svgTracability,
} from "@hermes/aphrodite/svg";

import { AgecPageRoutingModule } from "./agec-page-routing.module";
import { AgecPackagingsComponent } from "./components/agec-packagings/agec-packagings.component";
import { AgecPageComponent } from "./components/agec-page/agec-page.component";
import { AgecSearchBarComponent } from "./components/agec-search-bar/agec-search-bar.component";
import { AgecSearchResultComponent } from "./components/agec-search-result/agec-search-result.component";
import { AgecDangerousSubstancesComponent } from "./components/product-categories/agec-dangerous-substances/agec-dangerous-substances.component";
import { CompositionAttributeComponent } from "./components/product-categories/composition/composition-attribute.component";
import { RecyclabilityAttributeComponent } from "./components/product-categories/recyclability/recyclability-attribute.component";
import { TraceabilityAttributeComponent } from "./components/product-categories/tracability/traceability-attribute.component";
import { AgecHeadService } from "./head/agec-head.service";
import {
    ReplacePercentPipe,
    ReplacePercentPipeModule,
} from "./pipe/replace-percent.pipe";
import { AgecPageAnalyticsService } from "./services/agec-page-analytics.service";
import { AgecService } from "./services/agec.service";

@NgModule({
    imports: [
        AgecPageRoutingModule,
        CommonModule,
        SearchInputComponent,
        MessageBlockComponent,
        ReactiveFormsModule,
        ExpansionPanelComponent,
        ExpansionPanelPartDirective,
        SvgIconComponent,
        ReplacePercentPipeModule,
    ],
    declarations: [
        AgecDangerousSubstancesComponent,
        AgecPageComponent,
        AgecSearchBarComponent,
        AgecSearchResultComponent,
        AgecPackagingsComponent,
        CompositionAttributeComponent,
        TraceabilityAttributeComponent,
        RecyclabilityAttributeComponent,
    ],
    providers: [
        AgecService,
        AgecPageAnalyticsService,
        AgecHeadService,
        ReplacePercentPipe,
    ],
})
export class AgecPageModule {
    constructor(svgRegistryService: SvgRegistryService) {
        svgRegistryService.registerSvgs([
            svgSearch,
            svgComposition,
            svgTracability,
            svgRecyclability,
        ]);
    }
}
